import { ActionIcon, ActionIconProps, ElementProps } from '@mantine/core';
import clsx from 'clsx';
import { useUnit } from 'effector-react';
import { ChevronsRight } from 'lucide-react';
import { forwardRef } from 'react';
import { RegistryModel, Row } from 'shared/lib';

export type RegistryPaginationControlsEndProps = ActionIconProps &
	ElementProps<'button', keyof ActionIconProps>;

export const createRegistryPaginationControlsEnd = <
	TRow extends Row,
	TFilters extends Record<string, unknown>,
	TError,
	TAdditionalData = unknown,
>(
	model: RegistryModel<TRow, TFilters, TError, TAdditionalData>,
) => {
	const RegistryPaginationControlsEnd = forwardRef<
		HTMLButtonElement,
		RegistryPaginationControlsEndProps
	>(({ className, children, onClick, ...props }, ref) => {
		const [click, disabled] = useUnit([model.paginationEndClicked, model.$paginationEndDisabled]);

		return (
			<ActionIcon
				ref={ref}
				data-test-id='registry-pagination-controls-end'
				disabled={disabled}
				variant='outline'
				size='sm'
				className={clsx('registry-pagination-controls-end', className)}
				onClick={(event) => {
					click();
					onClick?.(event);
				}}
				{...props}
			>
				{children ?? <ChevronsRight />}
			</ActionIcon>
		);
	});

	return RegistryPaginationControlsEnd;
};
